import { environment } from '@env/environment';

// APIレスポンス変数名生成
export function createResponseName(url: string, method: string, res: any): string {
  // サンプル
  // if(url === "https://www.ana.co.jp/" && method === "post"){
  //   return `AAA_${res.cartId}`
  // }

  // チェックイン系のAPIへのprefix
  const checkinPathPrefix = environment.api.app.checkin;
  // サービシングのAPIへのprefix
  const servicingPathPrefix = environment.api.app.servicing;

  // チェックイン検索API
  if (url.includes(`${checkinPathPrefix}/journeys/search-journey`)) {
    return 'searchJourneyReply';
  }

  // CPR情報取得API
  if (url.includes(`${checkinPathPrefix}/journeys/get-journey`)) {
    return 'getJourneyReply';
  }

  // 同行者追加API
  if (url.includes(`${checkinPathPrefix}/add-companion`)) {
    return 'addCompanionReply';
  }

  // チェックイン搭乗者情報更新
  if (url.includes(`${checkinPathPrefix}/journeys/update-travelers`)) {
    return 'updateTravelersReply';
  }

  // CKIシートマップ取得
  if (url.includes(`${checkinPathPrefix}/checkin/get-seatmap`)) {
    return 'getSeatmapReply';
  }

  // チェックインサービス申し込み
  if (url.includes(`${checkinPathPrefix}/checkin/services`)) {
    return 'servicesReply';
  }

  // チェックイン取り消しAPI
  if (url.includes(`${checkinPathPrefix}/acceptance/cancel`)) {
    return 'cancelReply';
  }

  // チェックイン確定(注：チェックイン取り消しAPIと順序変更不可)
  if (url.includes(`${checkinPathPrefix}/acceptance`)) {
    return 'acceptanceReply';
  }

  // HPBP_PDF取得API
  if (url.includes(`${checkinPathPrefix}/boarding-passes/issue-hpbp`)) {
    return 'issueHpbpReply';
  }

  // MBPメール送信API
  if (url.includes(`${checkinPathPrefix}/boarding-passes/send-mbp`)) {
    return 'sendMbpReply';
  }

  // Walletデータ取得API
  if (url.includes(`${checkinPathPrefix}/boarding-passes/get-wallet`)) {
    return 'getWalletReply';
  }

  // チェックイン同行者削除
  if (url.includes(`${checkinPathPrefix}/delete-companion`)) {
    return 'deleteCompanionReply';
  }

  // フライトリスト取得API
  if (url.includes(`${checkinPathPrefix}/flights/get-flights`)) {
    return 'getFlightsReply';
  }

  // 空席待ち人数取得API
  if (url.includes(`${checkinPathPrefix}/travelers/get-standby-travelers`)) {
    return 'getStandbyTravelersReply';
  }

  // 予約検索パラメータ復号API
  if (url.includes(`${servicingPathPrefix}/orders/search-decryption`)) {
    return 'searchDecryptionReply';
  }

  return '';
}
